import React from "react";

const TermsOfService = () => {
	return <div>Terms Of Service</div>;
};

export default TermsOfService;
